'use client';

import { usePathname } from 'next/navigation';
import { AuthGuard } from '@/components/auth/auth-guard';
import { Sidebar } from '@/components/layout/sidebar';
import { Header } from '@/components/layout/header';

// Seiten, die als isolierter Vollbild-Screen ohne Sidebar/Header laufen
// muessen, aber TROTZDEM den Auth-Guard brauchen (Anmeldestatus pruefen,
// bei Bedarf weiterleiten) - aktuell nur /passwort-festlegen.
//
// Live-Fund 16.09.2026: /passwort-festlegen fehlte hier komplett und wurde
// dadurch, obwohl die Seite als eigener Vollbild-Screen gestaltet ist, immer
// INNERHALB der normalen Dashboard-Shell gerendert - die komplette Sidebar-
// Navigation blieb waehrend der erzwungenen Passwort-Aenderung sichtbar und
// klickbar, was genau das umgeht, was die erzwungene Passwort-Seite
// verhindern soll.
const SEITEN_OHNE_DASHBOARD_LAYOUT = new Set(['/passwort-festlegen']);

/**
 * AppShell – Umschalter zwischen Login-Layout und Dashboard-Layout.
 *
 * Login-Seite: Kein Sidebar, kein Header, kein Auth-Guard.
 * Passwort-Festlegen-Seite: Kein Sidebar, kein Header, ABER Auth-Guard
 * (regelt Anmeldestatus/Weiterleitung weiterhin).
 * Alle anderen Seiten: Vollständiges Dashboard-Layout mit Auth-Schutz.
 */
export function AppShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  // Login-Seite ohne Dashboard-Shell UND ohne Auth-Guard rendern
  if (pathname === '/login') {
    return <>{children}</>;
  }

  // Isolierter Vollbild-Screen mit Auth-Guard, aber ohne Sidebar/Header
  if (pathname && SEITEN_OHNE_DASHBOARD_LAYOUT.has(pathname)) {
    return <AuthGuard>{children}</AuthGuard>;
  }

  // Dashboard-Shell mit Auth-Guard
  return (
    <AuthGuard>
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex flex-1 flex-col overflow-hidden">
          <Header />
          <main className="flex-1 overflow-y-auto p-6">{children}</main>
        </div>
      </div>
    </AuthGuard>
  );
}
